enum TeaserType {
  SMALL = 'small',
  MINI = 'mini',
  LARGE = 'large',
  LANDSCAPE = 'landscape',
  STAGE = 'stage',
  HUB = 'hub',
}
export default TeaserType;
